module.exports = __webpack_public_path__ + "static/media/privacy-policy.065977e5.svg";